module.exports = __webpack_public_path__ + "static/media/spreader_manuals_active.9c3e03a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/spreader_manuals_active.svg
// module id = 1101
// module chunks = 36